import { useState } from 'react';
import ContractChartWidget from '../components/ContractChartWidget';
import RSIVWAPStudyTable from '../components/RSIVWAPStudyTable';

export default function BotTest() {
  const [selectedContract, setSelectedContract] = useState(null);

  return (
    <div>
      <ContractChartWidget contract={selectedContract} forceTf="5m" />
      <RSIVWAPStudyTable onSelect={setSelectedContract} />
    </div>
  );
}
